
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/courses/bootstrap-web-design-for-kids",
      function () {
        return require("private-next-pages/courses/bootstrap-web-design-for-kids.tsx");
      }
    ]);
  